import React, {useEffect, useState} from 'react'
import Navbar from '../components/navbar'
import { useSelectedFranchisee } from '../context/SelectedFranchiseeContext';
import { useUser } from '../context/UserContext';
import { FranchiseeModal } from '../components/FranchiseeModal';
import axios from 'axios';
import Swal from 'sweetalert2';

export default function TWSFranchisee() {
  const { selectedFranchisee, franchisees, updateSelectedFranchisee } = useSelectedFranchisee();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editFranchisee, setEditFranchisee] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDeleted, setShowDeleted] = useState(false);
  const { user, fetchUserData } = useUser();
 

  const handleEdit = (franchisee) => {
    const rcFlags = (franchisee.userAssociations || [])
      .map((association) => association.ringCentralCredential?.send_all_recording)
      .filter((value) => value !== undefined && value !== null);
    const send_all_recording = rcFlags.length > 0 && rcFlags.every(Boolean);

    setEditFranchisee({ ...franchisee, send_all_recording });
    setIsEditMode(true);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setEditFranchisee(null);
  };

  const filteredFranchisees = Array.isArray(franchisees)
  ? franchisees.filter((franchisee) => {
      const matchesSearch =
        franchisee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        franchisee.owner.toLowerCase().includes(searchTerm.toLowerCase());
      
      if (showDeleted) {
        return matchesSearch; // Include all, regardless of `deletedAt`
      }
      return franchisee.deletedAt === null && matchesSearch; // Only non-deleted
    })
  : [];
  const validateForm = () => {
    const errors = {};
    
    if (!editFranchisee?.assoc_client_type) {
      errors.assoc_client_type = 'Associated client is required.';
    }
    if (!editFranchisee?.owner) {
      errors.owner = 'Owner is required.';
    }
    if (!editFranchisee?.owner_email) {
      errors.owner = 'Owner Email is required.';
    }
    if (!editFranchisee?.name) {
      errors.name = 'Name is required.';
    }
    if (!editFranchisee?.slackChannelID) {
      errors.slackChannelID = 'Slack Channel ID is required.';
    }
    
    return errors;
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (['zips', 'dealStageId'].includes(name)) {
      setEditFranchisee((prev) => ({
        ...prev,
        settings: {
          ...prev.settings,
          [name]: value,
        },
      }));
    } else if (['upcoming_project', 'past_bid_date', 'warm_lead', 'hot_lead', 'meeting_booked', 'opp_fulfilled'].includes(name)) {
      setEditFranchisee((prev) => ({
        ...prev,
        pipeline_stages: {
          ...prev.pipeline_stages,
          [name]: value,
        },
      }));  
    } else {
      setEditFranchisee((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };
  
  

  const handleCreate = () => {
    setEditFranchisee({
      owner: '',
      owner_email: '',
      name: '',
      hubspot_api_key: '',
      settings: { zips: '', dealStageId: ''},
      slackChannelID: '',
      recordingChannelID: '',
      isRedirected: false,
      pipeline_stages: null,
      assoc_client_type: null,
      isCreatePipeline: false,
    }); // Set empty data for creation
    setIsEditMode(false); // Set to create mode
    setIsModalOpen(true); // Open modal
  };

  const handleDelete = async () => {
    if (!editFranchisee?.id) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Franchisee ID is missing. Please try again.',
      });
      return;
    }

    const result = await Swal.fire({
      title: editFranchisee.deletedAt !== null
        ? 'Restore Franchisee?'
        : 'Soft Delete Franchisee?',
      text: editFranchisee.deletedAt !== null
        ? 'Are you sure you want to restore this franchisee?'
        : 'Are you sure you want to soft delete this franchisee?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });
  
    if (!result.isConfirmed) {
      console.log("User canceled the action.");
      return;
    }
  
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const baseURL = process.env.REACT_APP_BACKEND_URL;
  
    try {
      const url = `${baseURL}/api/auth/franchisees/${editFranchisee.id}`;
      const isDeleted = editFranchisee.deletedAt !== null;
      const response = await axios.patch(
        url,
        { deletedAt: isDeleted ? null : new Date().toISOString() },
        { headers }
      );
  
      Swal.fire({
        icon: 'success',
        title: isDeleted ? 'Franchisee Restored!' : 'Franchisee Deleted!',
        text: response.data.message,
      });
  
      handleCloseModal(); 
      await fetchUserData(); 
      
    } catch (errors) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errors.response?.data?.message || 'An unexpected error occurred.',
      });
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const result = await Swal.fire({
      title: isEditMode
        ? 'Update Franchisee?'
        : 'Create New Franchisee?',
      text: isEditMode
        ? 'Are you sure you want to update this franchisee\'s information?'
        : 'Are you sure you want to create a new franchisee?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    });
  
    if (!result.isConfirmed) {
      console.log("User canceled the action.");
      return;
    }
    const errors = validateForm();
    const token = localStorage.getItem('authToken');
    const headers = token ? { Authorization: `Bearer ${token}` } : {};
    const baseURL = process.env.REACT_APP_BACKEND_URL;
  
    if (Object.keys(errors).length === 0) {
      try {
        const url = `${baseURL}/api/auth/franchisees`;
        console.log('Submitting to:', url);
        console.log('Payload:', editFranchisee);
  
        const response = isEditMode
          ? await axios.put(`${url}/${editFranchisee.id}`, editFranchisee, { headers })
          : await axios.post(url, editFranchisee, { headers });
    
        Swal.fire({
          icon: 'success',
          title: isEditMode ? 'Updated!' : 'Created!',
          text: 'The franchisee information was saved successfully.',
        });
  
        handleCloseModal();
        await fetchUserData();
      } catch (errors) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Unable to submit. Please try again later.',
        });
      }
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Errors',
        text: 'Please fix the errors in the form before submitting.',
      });
    }
  };
    
  useEffect(() => {
    const storedFranchisee = JSON.parse(localStorage.getItem('selectedFranchisee'));
    if (storedFranchisee) {
      updateSelectedFranchisee(storedFranchisee);
    }
     // eslint-disable-next-line
  }, []);

  return (
      <div className='w-full flex flex-col min-h-screen bg-gray-900  space-y-8'>
        <Navbar />
        <div className='mx-auto flex flex-col p-4 justify-center items-center'
        style={{ width: '90rem'}}>
          <h1 className="mb-5 text-2xl text-hs-background text-center flex-grow">
            LIST OF FRANCHISEES
          </h1>
          <div className="flex justify-between items-center w-full mb-4">
            <input
              type="text"
              placeholder="Search franchisees..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="border rounded p-2 w-1/5"
            />
    
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="showDeleted"
                  checked={showDeleted}
                  onChange={() => setShowDeleted((prev) => !prev)}
                  className="form-checkbox h-5 w-5 text-gray-600"
                />
                <label htmlFor="showDeleted" className="text-white">
                  Show Deleted
                </label>
              </div>
              <button
                onClick={handleCreate}
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
              >
                Create Franchisee
              </button>
            </div>
          </div>

        <div className="relative overflow-x-auto shadow-lg sm:rounded-lg" style={{ width: '88rem' }}>
          <table className="w-full  text-sm text-left rtl:text-right text-white cursor-pointer">
            <thead className="text-xs text-hs-background uppercase bg-hs-light-gray ">
              <tr>
                <th scope="col" className="px-4 py-3">
                    Owner
                </th>
                <th scope="col" className="px-4 py-3">
                    TWS Name
                </th>
                <th scope="col" className="px-4 py-3">
                    Hubspot API Key
                </th>
                <th scope="col" className="px-4 py-3">
                    SDR Assigned 
                </th>
                <th scope="col" className="px-4 py-3">
                    Zips
                </th>
                <th scope="col" className="px-4 py-3">
                    Slack Channel ID
                </th>
                <th scope="col" className="px-4 py-3">
                    Recording Channel ID
                </th>
                <th scope="col" className="px-4 py-3">
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredFranchisees.length > 0 &&
                filteredFranchisees.map((franchisee, index) => (
                  <tr
                    key={index}
                    onClick={() => !franchisee.deletedAt && updateSelectedFranchisee(franchisee)}
                    className={`${
                      selectedFranchisee?.id === franchisee.id
                        ? 'bg-hs-orange text-white hover:bg-hs-orange'
                        : franchisee.deletedAt
                        ? ' text-gray-100 hover:text-gray-500 hover:bg-hs-gray'
                        : 'hover:bg-hs-gray'
                    } bg-hs-background text-hs-dark-gray`}
                  >
                    <th scope="row" className="px-4 py-4">
                      {franchisee.owner}
                    </th>
                    <td className="px-4 py-4">{franchisee.name}</td>
                    <td className="px-4 py-4">
                      {franchisee?.client_type?.hubspot_api_key ? franchisee?.client_type?.hubspot_api_key : 'N/A'}
                    </td>
                    <td className="px-4 py-4">
                      {Array.isArray(franchisee?.users) && franchisee?.users?.length > 0
                        ? franchisee.users.map((user, index) => (
                            <p key={index}>
                              {user.email && user.email.length > 20 ? user.email.slice(0, 20) + '...' : user.email}
                            </p>
                          ))
                        : 'N/A'}
                    </td>
                    <td className="px-4 py-4 text-sm">
                    {franchisee?.settings && franchisee?.settings?.zips
                    ? (franchisee.settings.zips.length > 10
                        ? franchisee.settings.zips.slice(0, 10) + '...'
                        : franchisee.settings.zips)
                    : 'N/A'}
                    </td>
                    <td className="px-4 py-4">{franchisee.slackChannelID}</td>
                    <td className="px-4 py-4">{franchisee.recordingChannelID}</td>
                    <td className="px-4 py-4 text-sm">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleEdit(franchisee);
                        }}
                        className="bg-hs-blue text-white px-4 py-2 rounded hover:bg-hs-dark-blue"
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>

          </table>
        </div>
      </div>

      <FranchiseeModal
      isModalOpen={isModalOpen}
      isEditMode={isEditMode}
      editFranchisee={editFranchisee}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
      handleDelete={handleDelete}
      handleCloseModal={handleCloseModal}
      />
    </div>
  )
}
